/**
 * AJAX add-to-cart + open cart drawer for product forms outside s-product (e.g. hero ATC).
 */
(function () {
  "use strict";

  var FORM_SELECTOR = "form[js-cart-drawer-product-form]";

  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function getCartDrawerPanel() {
    return document.querySelector("#CartDrawer");
  }

  function setButtonsLoading(form, loading) {
    form.querySelectorAll("[js-add-to-cart]").forEach(function (button) {
      if (loading) {
        button.setAttribute("disabled", "");
        var spinner = button.querySelector("loading-spinner");
        if (spinner) spinner.setAttribute("loading", "");
      } else {
        button.removeAttribute("disabled");
        var spinner = button.querySelector("loading-spinner");
        if (spinner) spinner.removeAttribute("loading");
      }
    });
  }

  function showError(form, message) {
    var errorEl = form.querySelector("[js-error-message]");
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.classList.remove("hidden");
    } else {
      errorEl.textContent = "";
      errorEl.classList.add("hidden");
    }
  }

  async function onSubmit(event) {
    var form = event.currentTarget;
    event.preventDefault();

    var cart = getCartDrawer();
    var cartDrawer = getCartDrawerPanel();

    showError(form, false);
    setButtonsLoading(form, true);

    try {
      var formData = new FormData(form);
      var variantId = formData.get("id");
      var quantity = formData.get("quantity") || 1;

      if (!variantId) {
        throw new Error("Please select a variant.");
      }

      var addUrl =
        (window.routes && window.routes.cart_add_url) ||
        ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "cart/add.js";

      var payload = {
        items: [{ id: variantId, quantity: quantity }],
        sections_url: window.location.pathname,
      };

      if (cart && typeof cart.getSectionsToRender === "function") {
        payload.sections = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
      }

      var response = await fetch("" + addUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify(payload),
      });

      var data = await response.json();

      if (data.status) {
        if (window.theme && theme.utils && theme.utils.subscriptions && window.PUB_SUB_EVENTS) {
          theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: variantId,
            errors: data.errors || data.description,
            message: data.message,
          });
        }
        showError(form, data.description || data.message || "Could not add to cart.");
        return;
      }

      if (window.theme && theme.utils && theme.utils.subscriptions && window.PUB_SUB_EVENTS) {
        theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: variantId,
        });
      }

      if (document.querySelector("cart-items")) {
        document.querySelector("cart-items").onCartUpdate();
      }
      if (document.querySelector("cart-drawer-items")) {
        document.querySelector("cart-drawer-items").onCartUpdate();
      }

      if (cart && typeof cart.renderContents === "function") {
        cart.renderContents(data);
        if (cartDrawer && cartDrawer.getAttribute("aria-hidden") === "true" && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || "/cart";
      }
    } catch (error) {
      console.error(error);
      showError(form, error.message || "Could not add to cart.");
    } finally {
      setButtonsLoading(form, false);
    }
  }

  function initForm(form) {
    if (!form || form.dataset.cartDrawerFormInit === "true") return;
    if (form.closest("s-product")) return;

    form.dataset.cartDrawerFormInit = "true";
    form.addEventListener("submit", onSubmit);
  }

  function initAll(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll(FORM_SELECTOR).forEach(initForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
